import React, { createContext, useReducer, useContext } from "react";

export const CommandeContext = createContext();

// Initial state
const initialState = {
	quantiteTotale: 0,
	dureeTotale: 0,
	quantiteTotaleOptions: 0,
	equipementMarque: '',
	equipementModele: '',
	problemeDescription: '',
	montantOptions: 0,
	montantInitial: 0,
	initState: false,
	produit: undefined,
	commune: undefined,
	adresse: '',
	adresseComplement: '',
	hasAdresseFacturation: false,
	communeFacturation: undefined,
	adresseFacturation: '',
	adresseComplementFacturation: '',
	creneau: undefined,
	typePaiement: undefined,
	tarif: undefined,
	codePromo: '',
	clientType: 'particulier',
	clientNomEntreprise: '',
	clientIdentifiantEntreprise: '',
	contactCivilite: '',
	contactNom: '',
	contactPrenom: '',
	contactTelephoneMobile: '',
	contactTelephoneFixe: '',
	contactEmail: '',
	contactEmailConfirmation: '',
	acceptCGV: false,
	isPlus2ans: true
};

// Actions
export const CHANGE_VALEUR = "CHANGE_VALEUR";
// Cas fictif uniquement pour eviter les warning au niveau du switch
export const CHANGE_AUTRE = "CHANGE_AUTRE";

// Action creators
export function changeValeur(key, value) {
	return { type: CHANGE_VALEUR, key, value };
}

export function changeAutre(key, value) {
	return { type: CHANGE_AUTRE, key, value };
}

function updateQuantiteTotale(commande) {
	let result = 0;
	// parcours des unites de travail du produit pour voir si des quantites sont initialisées dans la commande
	commande.produit.unitesTravail.map((ut) => {
		// Récupération de la quantite correspondante dans la commande si elle existe
		let qteTmp = commande[ut.workUnitKey];
		if(qteTmp > 0) {
			result += qteTmp;
		}
		return 0;
	});
	return result;
}

function updateDureeTotale(commande) {

	let result = 0;
	
	// parcours des unites de travail du produit pour voir si des quantites sont initialisées dans la commande
	commande.produit.unitesTravail.map((ut) => {
		// Récupération de la quantite correspondante dans la commande si elle existe
		let qteTmp = commande[ut.workUnitKey];
		if(qteTmp > 0) {
			// Calcul de la durée totale pour l'unite de travail
			result += (qteTmp * ut.dureeMainOeuvre);
		}
		return 0;
	});
	
	// On ajoute la durée de mise en place qui est associée au produit	
	if (result > 0)
		result += commande.produit.tarification.dureeMiseEnPlace;
	
	return result;
}

function updateQuantiteTotaleOptions(commande) {
	let result = 0;
	// parcours des unites de travail du produit pour voir si des quantites sont initialisées dans la commande
	commande.produit.optionsUnitesTravail.map((ut) => {
		// Récupération de la quantite correspondante dans la commande si elle existe
		let qteTmp = commande[ut.workUnitKey];
		if(qteTmp > 0) {
			result += qteTmp;
		}
		return 0;
	});
	return result;
}

function updateMontantOptions(commande) {

	let result = 0;
	
	// parcours des unites de travail du produit pour voir si des options sont initialisées dans la commande
	commande.produit.optionsUnitesTravail.map((ut) => {
		// Récupération de la quantite correspondante dans la commande si elle existe
		let qteTmp = commande[ut.workUnitKey];
		if(qteTmp > 0) {
			// Calcul de la durée totale pour l'unite de travail
			result += (qteTmp * ut.forfaitMainOeuvre);
		}
		return 0;
	});
	
	return result;
}

// Reducer
export function commandeReducer(state, action) {

	let retVal = state;

	switch (action.type) {

		case CHANGE_VALEUR:
			retVal = { ...state, [action.key]: action.value };

			// S'il s'agit de a mise à jour d'une quantité alors on met à jour la quantité totale et la durée totale
			if (action.key.startsWith('ut-')) {
				
				// Mise à jour de la quantite totale
				let quantiteTotaleTmp = updateQuantiteTotale(retVal);
				retVal = { ...retVal, quantiteTotale: quantiteTotaleTmp };

				// Mise à jour de la durée totale
				let dureeTotaleTmp = updateDureeTotale(retVal);
				retVal = { ...retVal, dureeTotale: dureeTotaleTmp };
				
				// Initialisation de la variable permettant la réinitilisation de la commande
				retVal = { ...retVal, initState: true};
				retVal = { ...retVal, creneau: undefined};
				retVal = { ...retVal, typePaiement: undefined};
				retVal = { ...retVal, tarif: undefined};
			}
			
			// S'il s'agit de a mise à jour d'une quantité d'option alors on met à jour le tarif total
			if (action.key.startsWith('option-ut-')) {
				
				// Mise à jour de la quantite totale
				let quantiteTotaleOptionsTmp = updateQuantiteTotaleOptions(retVal);
				retVal = { ...retVal, quantiteTotaleOptions: quantiteTotaleOptionsTmp };
								
				// Mise à jour du montant des options
				let montantOptionsTmp = updateMontantOptions(retVal);
				retVal = { ...retVal, montantOptions: montantOptionsTmp };
				
				// Initialisation de la variable permettant la réinitilisation de la commande
				retVal = { ...retVal, initState: true};
				retVal = { ...retVal, creneau: undefined};
				retVal = { ...retVal, typePaiement: undefined};
				retVal = { ...retVal, tarif: undefined};
			}
			
			if(process.env.REACT_APP_ENV !== 'PRD'){
				console.log(action.key);
				console.log(retVal);
			}
				
			return retVal;

		// Cas fictif uniquement pour eviter les warning au niveau du switch
		case CHANGE_AUTRE:
			return retVal;

		default:
			if(process.env.REACT_APP_ENV !== 'PRD'){
				console.log(retVal);
			}
			return retVal;
	}
}

function CommandeProvider(props) {

	// Initialisation du useReducer Hook qui renvoie l'état + une fonction
	const [commande, dispatch] = useReducer(commandeReducer, initialState);

	// Initialisation de l'état et de la fonction dispatch qui sera utilisée dans les composants
	const commandeData = { commande, dispatch };

	// Renvoi du provider initialisé
	return <CommandeContext.Provider value={commandeData} {...props} />;
}

// Custom hook that allows us to consume the commande context
function useCommandeContext() {

	const context = useContext(CommandeContext)
	if (context === undefined) {
		throw new Error('context is undefined as it must be used within a CommandeProvider')
	}
	return context;
}

export { CommandeProvider, useCommandeContext };